import React from 'react';
import CompliancePage from '../components/CompliancePage';
import { COMPLIANCE_PAGES } from '../config';

const ContactUsPage = () => {
  return <CompliancePage pageData={COMPLIANCE_PAGES.contactUs} />;
};

export default ContactUsPage;
